import { render, staticRenderFns } from "./color.vue?vue&type=template&id=516922c0&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports